
import { defineComponent, ref, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router/index";
import SelectAttributeLine from "@/components/SelectAttributeLine.vue";
import { useSelectAttribute } from "@/lib/selectedAttribute";
import store from "@/stores";
import { useLogger } from "@/lib/logger";
import { SelectedAttribute, consts } from "@/services/Models";

export default defineComponent({
  name: "FilterAttribute",
  components: {
    SelectAttributeLine,
  },
  setup() {
    const resource = store.useResource();
    const router = useRouter();
    const logger = useLogger();
    const helper = computed(() =>
      useSelectAttribute(
        resource.data.attributeGroups.filter(
          (x) => x.id !== consts.checkboxAttrGroupID
        ),
        []
      )
    );

    // 指定された属性で絞り込んだ結果数
    const filteredCount = computed<number>(() => {
      const filtered = helper.value.groupWithList.reduce(
        (xs, g) => {
          const selectedIDs = g.selectedList.value;
          if (selectedIDs.length == 0) {
            // 全て指定なしならテンプレート群をそのまま返す
            return xs;
          }
          // 指定された属性で絞り込む
          return xs.filter((x) =>
            selectedIDs.some((id) => x.tags.some((t) => t.id == id))
          );
        },
        // 作者がシステム以外のテンプレートをアキュムレータの初期値とする
        resource.data.templateSets.filter(
          (x) =>
            x.frames.some((frame) => frame.author.id != consts.systemAuthor) &&
            x.deleteFlg == false
        )
      );
      return filtered.length;
    });

    const isShowModal = ref(false);
    const preSearch = () => {
      isShowModal.value = true;
    };
    const toSearch = () => {
      const attributeGroups = resource.data.attributeGroups;

      //属性グループと属性の紐付け。（複数選択可能）
      const choices = attributeGroups.map((x) => {
        const selectedAttributes = x.attributes.filter((y) =>
          helper.value.selectedAttributeIDs.value.includes(y.id)
        );
        const tmp = selectedAttributes.map((x) => x.name);
        if (tmp.length == 0) tmp.push("指定なし");
        return {
          attributeGroup: x.name,
          selectedAttributes: tmp,
        };
      });
      const sendLogInfo: SelectedAttribute = {
        action: routeNames.SearchTemplate,
        options: {
          choices: choices,
        },
      };

      //ユーザーログ書き込み(属性絞り込み時のログ)
      logger.log(sendLogInfo);
      router.push({
        name: routeNames.SearchTemplate,
        query: {
          attributeID: helper.value.selectedAttributeIDs.value,
        },
      });
    };

    watch(
      () => isShowModal.value,
      (newVal) => {
        if (!newVal) {
          for (var i = 0; i < helper.value.groupWithList.length; i++) {
            helper.value.groupWithList[i].selectedList.value = [];
          }
        }
      }
    );

    return {
      helper,
      isShowModal,
      preSearch,
      toSearch,
      filteredCount,
    };
  },
});
